import { useContext } from 'react';
import ShellRootContext from './ShellRootContext';
// This is the hook recommended by Jarvis to access to JSHELL properties.
const useShellRootContext = () => useContext(ShellRootContext);

export default useShellRootContext;
